import React from 'react'
import KioskLayout from 'src/chamberScreen/layout/KioskLayout'

// first level routes
const ClinicLandingPage = React.lazy(() => import('./components/ClinicLandingPage'))
const ClinicHomePage = React.lazy(() => import('./components/ClinicHomePage'))
const ClinicBrandHomePage = React.lazy(() =>
  import('./components/ClinicHomePage/ClinicBrandHomepage'),
)
const ClinicManageBookingsPage = React.lazy(() => import('./components/ClinicManageBookingsPage'))
const ClinicCounterForMentor = React.lazy(() =>
  import('./components/ClinicCounterScreen/ClinicCounterForMentor'),
)
const ClinicCounterScreen = React.lazy(() => import('./components/ClinicCounterScreen'))
const ClinicPrescriptionPage = React.lazy(() =>
  import('./components/ClinicManageBookingsPage/ClinicPrescriptionPage'),
)
const ClinicBrandOnboardingPage = React.lazy(() =>
  import('./views/onboardng/ClinicBrandOnboardingPage'),
)
const ClinicOnboardingPage = React.lazy(() =>
  import('./views/onboardng/ClinicLocationOnboardingPage'),
)
const PharmacyDataBasePage = React.lazy(() => import('./views/pharmacyDatabase/PharmacyDatabase'))
const PatientHistoryPage = React.lazy(() => import('./views/patientListing/PatientHistoryPage'))
const ClinicCommunicationsPage = React.lazy(() =>
  import('./views/clinicCommunications/ClinicCommunicationsPage'),
)
const PatientListingPage = React.lazy(() => import('./views/patientListing/PatientListingPage'))
const SatelliteChamberPage = React.lazy(() => import('./components/SatelliteChamberPage'))
const ClinicManageWorkforcePage = React.lazy(() => import('./components/ClinicManageWorkforcePage'))
const ClinicAssistantResponsibilitiesPage = React.lazy(() =>
  import('./components/ClinicAssistantResponsibilitiesPage'),
)
const ClinicProfile = React.lazy(() => import('./views/profile/ClinicLocationProfile'))
const PlannedAppointmentsPage = React.lazy(() =>
  import('./views/plannedAppointments/ClinicAssistantPlannedAppointmentsTab'),
)
const ClinicBrandProfile = React.lazy(() => import('./views/profile/ClinicBrandProfile'))
const ClinicBrandPeople = React.lazy(() => import('./views/profile/ClinicBrandPeople'))
const ClinicSchedule = React.lazy(() => import('./views/clinicSchedule/ClinicSchedulePage'))
const ClinicServices = React.lazy(() => import('./views/clinicServices/ClinicAppointmentTypes'))
const KioskSelectFlowPage = React.lazy(() => import('./components/KioskSelectFlowPage'))

const ClinicBrandPayoutReports = React.lazy(() =>
  import('./views/clinicBrandPayoutReports/BrandPayoutReports'),
)

///clinic-home and ca-home is there before all these routes. check App.js

export const primaryRoutes = [
  // 1. IDK WHAT TO DO FOR THESE ROUTES:

  // THIS ONE CANT BE SUPPORTED HERE: ONLY FOR DOCTOR
  {
    path: ':clinicBrandId/:clinicId/patient-list/:patientId',
    exact: true,
    name: 'Patient History',
    Element: PatientHistoryPage,
  },

  // {
  //   path: ':clinicBrandId/:clinicId/agreements',
  //   exact: true,
  //   name: 'Agreements',
  //   Element: PharmacyDataBasePage,
  // },

  // 2. All below this okay:
  {
    path: ':clinicBrandId/:clinicId/assistant-responsibility/*',
    exact: true,
    name: 'Update Clinic Assistant Responsibilities',
    Element: ClinicAssistantResponsibilitiesPage,
  },
  {
    path: ':clinicBrandId/:clinicId/manage-workforce/*',
    exact: true,
    name: 'Update Clinic Location Staff',
    Element: ClinicManageWorkforcePage,
  },
  {
    path: ':clinicBrandId/:clinicId/update-location-details/*',
    name: 'Clinic Profile',
    exact: true,
    Element: ClinicProfile,
  },
  {
    path: 'new-brand-onboarding',
    name: 'Clinic Brand Onboarding',
    exact: true,
    Element: ClinicBrandOnboardingPage,
  },
  {
    path: ':clinicBrandId/update-brand-people',
    exact: true,
    name: 'Update people for existing Brand',
    Element: ClinicBrandPeople,
  },
  {
    path: ':clinicBrandId/update-brand-details',
    exact: true,
    name: 'Update details for existing Brand',
    Element: ClinicBrandProfile,
  },
  {
    path: ':clinicBrandId/new-clinic',
    exact: true,
    name: 'Clinic Onboarding for existing Brand',
    Element: ClinicOnboardingPage,
  },
  {
    path: ':clinicBrandId/:clinicId/manage-bookings/prescription/:bookingId',
    exact: true,
    name: 'See Prescription',
    Element: ClinicPrescriptionPage,
  },
  {
    path: ':clinicBrandId/:clinicId/manage-bookings/*',
    exact: true,
    name: 'Manage Calendar',
    Element: ClinicManageBookingsPage,
  },
  {
    path: 'display/:clinicLocationSlug/:mentorSlug',
    exact: true,
    name: 'Kiosk Display Screen For a Mentor',
    Element: ClinicCounterForMentor,
  },
  {
    path: ':clinicBrandId/:clinicId/counter-screen/:mentorId',
    exact: true,
    name: 'Counter Screen For a Mentor',
    Element: ClinicCounterForMentor,
  },
  {
    path: ':clinicBrandId/:clinicId/counter-screen',
    exact: true,
    name: 'Counter Screen',
    Element: ClinicCounterScreen,
  },
  {
    path: ':clinicBrandId/:clinicId/satellite-chamber',
    exact: true,
    name: 'Satellite Chamber',
    Element: SatelliteChamberPage,
  },
  // need to have this for doctor and pharmacist later
  {
    path: ':clinicBrandId/:clinicId/pharmacy-database/*',
    exact: true,
    name: 'Pharmacy Database',
    Element: PharmacyDataBasePage,
  },
  {
    path: ':clinicBrandId/:clinicId/patient-list/*',
    exact: true,
    name: 'Patient List',
    Element: PatientListingPage,
  },
  {
    path: ':clinicBrandId/:clinicId/communications',
    exact: true,
    name: 'Clinic Communications Page',
    Element: ClinicCommunicationsPage,
  },
  {
    path: ':clinicBrandId/:clinicId/schedule/*',
    name: 'Clinic Schedule',
    exact: true,
    Element: ClinicSchedule,
  },
  {
    path: '/chamber-screen-home/*',
    name: 'Chamber Screen Home',
    exact: true,
    Element: KioskLayout,
  },
  {
    path: 'select-flow',
    name: 'Kiosk Select Flow',
    exact: true,
    Element: KioskSelectFlowPage,
  },
  { path: ':clinicBrandId/:clinicId', exact: true, name: 'Home', Element: ClinicHomePage },
  { path: ':clinicBrandId', exact: true, name: 'Home', Element: ClinicBrandHomePage },
  {
    path: ':clinicBrandId/payout-reports',
    exact: true,
    name: 'Brand Reports',
    // Element: ClinicBrandPayoutReports,
    Element: ClinicBrandPayoutReports,
  },
  {
    path: ':clinicBrandId/:clinicId/clinic-services',
    exact: true,
    name: 'Clinic Services',
    // Element: ClinicBrandPayoutReports,
    Element: ClinicServices,
  },
  {
    path: ':clinicBrandId/:clinicId/planned-appointments',
    exact: true,
    name: 'Planned Appointments',
    // Element: ClinicBrandPayoutReports,
    Element: PlannedAppointmentsPage,
  },
  { path: '/', exact: true, name: 'Home', Element: ClinicLandingPage },
]
